@if (display) {
    <div class="modal-content">
        <span [nzTwotoneColor]="'#ffd500'" nz-icon nzTheme="twotone" nzType="warning" class="fs-64"></span>
        @if (duration < DAYS) {
            <h1 class="text-32-light mt-10">
                Votre période d’essai de {{duration}} jours a expiré !
            </h1>
        } @else {
            <h1 class="text-32-light mt-10">
                Votre période d’essai d'1 an a expiré !
            </h1>
        }
        
        @if (!isOwner) {
            <div class="wrapper-expiration">
                <p>Si vous souhaitez plus d'informations ou souscrire à un abonnement, contactez votre <strong>{{partnerLabel}}</strong>.</p>
            </div>
        }
    </div>
} @else {
    <div class="modal-content">
        <nz-spin class="loaderTemplate" nzSimple [nzSize]="'large'"></nz-spin>
    </div>
}
